import * as autoLoansAPI from '../apis/autoLoansAPI';
import * as createLoanUtils from './createLoanUtils';
import * as featureFlags from './featureFlags';
import * as loanUtils from './loanUtils';
import * as userUtils from './userUtils';
import { getWindow } from './globalWrappers';

// Ultimately this should return true whenever the user is logged in,
// but while we support the applicationChooserInDropdownMenu20190109 FF, we need to
// check the selectedProductId cookie and the FF.
export function shouldCreateOrUpdateAutoLoan(): boolean {
  return (
    !!userUtils.getCurrentUser() &&
    (featureFlags.isEnabled('applicationChooserInDropdownMenu20190109') || !!loanUtils.getSelectedProductId())
  );
}

export async function createOrUpdateAutoLoan(subType: AutoLoanSubType) {
  const selectedProductId = loanUtils.getSelectedProductId();
  if (!selectedProductId) {
    // Create a new Auto loan if there is no product selected
    await createLoanUtils.addNewLoanToBorrower({
      loanType: 'AUTO',
      modelProperties: subType,
    });
    return;
  }
  await autoLoansAPI.updateAutoLoanSubType(selectedProductId, subType);
  // Reload the page to redirect the user to the borrower app
  getWindow().location.reload();
  return;
}
